<template>
  <header class="app-header">
    <div class="app-logo"></div>
    <!-- <lang></lang> -->
    <nav class="app-nav">
      <ul class="app-menu">
        <li class="menu-item" v-for="item in menu" :key="item.path">
          <router-link class="menu-link" :class="path === item.path ? 'active' : ''" :to="item.path">{{ $t(`menu.${item.path.substring(1) || 'inicio'}`) }}</router-link>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import Lang from '@/components/util/Lang';
export default {
  components: {
    Lang
  },
  mounted () {
    this.path = this.$route.path;
  },
  data () {
    return {
      path: '/',
      menu: [
        { path: '/home', label: this.$t('menu.inicio') },
        { path: '/tramite', label: this.$t('menu.tramite') },
        { path: '/solicitud', label: this.$t('menu.solicitud') },
        { path: '/seguimiento', label: this.$t('menu.seguimiento') },
        { path: '/verificar', label: this.$t('menu.verificar') }
        // { path: '/contacto', label: this.$t('menu.contacto') }
      ]
    };
  },
  watch: {
    '$route' (to, from) {
      this.path = to.path;
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';

.app-header {
  overflow: hidden;
  position: relative;
  z-index: 2;
}

.app-logo {
  width: 525px;
  height: 125px;
  margin: 14px auto 10px auto;
  background-image: url(../../../static/images/minedu.039e88e9.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

@media (max-width: 768px) {
  .app-logo {
    width: 100%;
    max-width: 240px;
    height: 80px;
    margin: 20px auto 10px auto;
  }
}

.app-nav {
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  text-align: center;
}

.app-menu {
  list-style: none;
  padding: 0;
  display: inline-block;
  margin: 0 auto;

  .menu-item {
    display: inline-block;
    text-transform: uppercase;
  }

  .menu-link {
    line-height: 42px;
    text-decoration: none;
    color: #333;
    padding: 0 15px;
    display: inline-flex;
    font-size: .9rem;
    position: relative;
    transition: all ease .3s;
    outline: 0;

    &:before {
      content: '';
      transition: all ease .3s;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      display: block;
      height: 2px;
    }

    &:hover, &.active {
      color: $primary;

      &:before {
        background-color: $primary;
      }
    }

    &:active, &:focus {
      outline: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/AppHeader.vue